import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import defaultLogoSrc from '../../assets/images/boundly-logo.png';
import styles from './Logo.css';

const cx = classnames.bind(styles);

function Logo({ className, onClick, url, src = defaultLogoSrc }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <CustomLink
            to={url}
            className={classes}
            onClick={onClick}
        >
            <img src={`${src}?v=2`} alt='Boundly' />
        </CustomLink>
    );
}

Logo.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    url: PropTypes.string,
    src: PropTypes.string
};

Logo.defaultProps = {
    onClick: null,
    className: '',
    url: '/'
};

export {
    Logo
};
